import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import CustomApplicationState from "@thos/Store/CustomApplicationState";

export const getFulfillmentLabel = (state: CustomApplicationState) => {
    const { fulfillmentMethod, isAuthenticated, rememberMe, isGuest, billToId, shipToId, pickUpWarehouse } =
        getSession(state);
    const currentShipFromWarehouse = state.ThosState.shipFromWarehouseState.currentShipFromWarehouse;
    const billToState = getBillToState(state, billToId);
    const shipToState = getShipToState(state, shipToId);
    const { value: shipTo } = shipToState;
    const { value: billTo } = billToState;
    let addressLabel = translate("Ship");
    if (
        fulfillmentMethod === FulfillmentMethod.Ship &&
        (isAuthenticated || rememberMe) &&
        !isGuest &&
        (shipTo || billTo)
    ) {
        // “Ship to” [BillTo Customer Name] – [ShipTo #] (if a ShipTo number is being used) “from” [Warehouse]
        addressLabel = translate(
            "Ship to {0} {1}",
            `${billTo?.companyName || shipTo?.companyName}${shipTo !== undefined && shipTo.customerSequence !== "" ? ` - ${shipTo.customerSequence}` : ""
            }`,
            currentShipFromWarehouse ? `from ${currentShipFromWarehouse.description || currentShipFromWarehouse.name}` : "",
        );
    } else if (fulfillmentMethod === FulfillmentMethod.PickUp) {
        addressLabel = translate(
            "Pick up {0}",
            pickUpWarehouse ? `at ${pickUpWarehouse.description || pickUpWarehouse.name}` : "",
        );
    }

    return addressLabel;
};
